import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';

const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Table",
    no_data_text: 'Records Not Found!',
    language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
            first: "|<",
            previous: "<",
            next: ">",
            last: ">|"
        }
    },
    show_length_menu: false,
    show_filter: true,
    show_pagination: true,
    show_info: true,
};

const ReactDataTable = ({ columns, records, setPagination, count, loader }) => {

    const handlePagination = (index) => {
        
        let reqData = {
            page: index.page_number,
            limit: index.page_size,
            search: index.filter_value,
            sort: index?.sort_order ? (index?.sort_order["order"] === 'asc' ? JSON.stringify({ [index?.sort_order["column"]]: 1 }) : JSON.stringify({ [index?.sort_order["column"]]: -1 })) : null
        }
        setPagination(reqData)
    }

    return (
        <ReactDatatable
            responsive={true}
            config={config}
            records={records}
            columns={columns}
            dynamic={true}
            total_record={count}
            loading={loader}
            onChange={handlePagination}
        />
    )
}

export default React.memo(ReactDataTable);